module.exports = __webpack_public_path__ + "img/uefa-europa-league-113__dark.3d8c2b76.png";